module.exports = __webpack_public_path__ + "img/icon_whiteArtboard 1.8e468dbf.png";